module.exports = __webpack_public_path__ + "img/logo_charleroi_entreprendre.e72811e1.png";